import { css } from "@emotion/react";

import theme from "../../styles/theme";
import { greyF7, black1D } from "../../styles/variables";

const { spacing } = theme;

export const item = css`
  margin-bottom: ${spacing(1)}px;
`;

export const codeBlock = css`
  padding: ${spacing(2)}px;
  border-radius: 4px;
  background: ${greyF7};
  outline: none;

  .MuiInputBase-root {
    color: ${black1D};
    font-weight: bold;
  }
`;
